/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import { getRouterMap, constantRouter } from '@/pages/index/router'
import path from 'path'
import gobal from '@/utils/common.js'
Vue.use(Vuex)
export const filterResource = (data, result) => {
  if (data.children) {
    data.children.filter(children => {
      filterResource(children, result)
    })
  }
  result[data.id] = data
}

export const hasPermission = (router, perName) => {
  if (router.meta && router.meta.id !== undefined && router.meta.id !== '') {
    try {
      let info = perName[router.meta.id]
      if (info) {
        router.menuName = info.name
        router.meta.menuName = info.name
        router.icon = info.icon
        router.i18nKey = info.i18nKey
        // if (router.meta) {
        //   router.meta['i18nKey'] = info.i18nKey
        // } else {
        //   router.meta = { 'i18nKey': info.i18nKey }
        // }
      }
    } catch (e) {}
  }
  if (router.meta && router.meta.auth === false) {
    return true
  }
  if (router.meta && router.meta.auth === true) {
    if (router.meta.id === undefined || router.meta.id === '') {
      return false
    }
    if (perName[router.meta.id]) {
      return true
    }
    return false
  } else {
    return false
  }
}

export const filterAsyncRouter = (routerMap, permission) => {
  const accessedRouters = routerMap.filter(route => {
    if (hasPermission(route, permission)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, permission)
      }
      return true
    }
    return false
  })
  return accessedRouters
}

export const RouterIdS = (data, result) => {
  if (Array.isArray(data)) {
    data.forEach(item => {
      if (item.meta && item.meta.id) {
        result[item.meta.id] = item
      }
      if (item.children) {
        RouterIdS(item.children, result)
      }
    })
  } else {
    if (data.meta && data.meta.id) {
      result[data.meta.id] = data
    }
  }
}

export const setMenu = (menu, RouterIdS) => {
  if (Array.isArray(menu)) {
    menu.forEach(item => {
      let routerInfo = RouterIdS[item.id]
      if (routerInfo) {
        item.url = routerInfo.path
        if (routerInfo.hidden) {
          item.hidden = routerInfo.hidden
        }
      }
      if (item.children) {
        setMenu(item.children, RouterIdS)
      }
    })
  } else {
    let routerInfo = RouterIdS[menu.id]
    if (routerInfo) {
      menu.url = routerInfo.path
    }
    if (menu.children) {
      setMenu(menu.children, RouterIdS)
    }
  }
}

export const getAllResourceObj = (resource, Obj) => {
  if (Array.isArray(resource)) {
    resource.forEach(item => {
      Obj[item.id] = {
        id: item.id,
        status: item.status
      }
      if (item.children) {
        getAllResourceObj(item.children, Obj)
      }
    })
  } else {
    Obj[resource.id] = {
      id: resource.id,
      status: resource.status
    }
    if (resource.children) {
      getAllResourceObj(resource.children, Obj)
    }
  }
}

export const filterStatus = menu => {
  if (Array.isArray(menu)) {
    const menuResult = menu.filter(item => {
      if (item.status === 1) {
        if (item.children && item.children.length) {
          item.children = filterStatus(item.children)
        }
        return true
      }
      return false
    })
    return menuResult
  } else {
    if (menu.status === 1) {
      if (menu.children && menu.children.length) {
        menu.children = filterStatus(menu.children)
      }
      return menu
    } else {
      return null
    }
  }
}

export const filterMenu = menu => {
  menu.forEach(item => {
    if (item.children && item.children.length) {
      item.children.forEach(childrenItem => {
        if (childrenItem.resourceType === 1 && !childrenItem.hidden) {
          item.childrenCount = item.childrenCount ? item.childrenCount + 1 : 1
          item.childrenMenuItem = childrenItem
        }
      })
    }
  })
  return menu
}

//重构菜单
export const restructureMenu = menu => {
  let menuResult = []
  menu.forEach(item => {
    if (item.childrenCount && item.childrenCount === 1) {
      let icon = item.icon
      let child = item.childrenMenuItem
      child.icon = icon
      menuResult.push(child)
    } else {
      menuResult.push(item)
    }
  })
  return menuResult
}

export default new Vuex.Store({
  state: {
    winInfo: {
      clientWidth: 500,
      clientHeight: 500,
      routerViewHeight: 500
    },
    isCompanyUser: false,
    accessedRouters: [],
    resourceTree: {},
    isLoadRouter: false,
    isLoginAuto: false,
    menuObject: {},
    orgType: [],
    breadcrumb: [],
    menuTree: {},
    resourceList: {},
    theme: '#05203B', // #05203B
    breadTheme: '#fff',
    userInfo: null,
    menuMode: 'horizontal', // horizontal or vertica
    appMode: 'appList',
    appKey: '',
    collapse: false,
    changeAvater: null
  },
  mutations: {
    setAvater(state, changeAvater) {
      state.changeAvater = changeAvater
    },
    setCollapse(state, collapse) {
      state.collapse = collapse
    },
    setWinInfo(state, winInfo) {
      state.winInfo = winInfo
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setAppKey(state, appKey) {
      sessionStorage.setItem('appKey', appKey)
      state.appKey = appKey
    },
    setAppMode(state, appMode) {
      state.appMode = appMode
    },
    setIsCompanyUser(state, isCompanyUser) {
      state.isCompanyUser = isCompanyUser
    },
    setIsLoginAuto(state, isLoginAuto) {
      state.isLoginAuto = isLoginAuto
    },
    setMenuMode(state, menuMode) {
      state.menuMode = menuMode
    },
    setOrgType(state, orgType) {
      state.orgType = orgType
    },
    setAccessedRouters(state, accessedRouters) {
      state.accessedRouters = accessedRouters
    },
    setIsLoadrouter(state, isLoad) {
      state.isLoadRouter = isLoad
    },
    setResourceTree(state, resourceTree) {
      state.resourceTree = resourceTree
    },
    setmenuObject(state, menuObject) {
      state.menuObject = menuObject
    },

    setmenuTree(state, menuTree) {
      state.menuTree = menuTree
    },
    setBreadcrumb(state, breadcrumb) {
      state.breadcrumb = breadcrumb
    },
    setTheme(state, theme) {
      state.theme = theme
    },
    setBreadTheme(state, breadTheme) {
      state.breadTheme = breadTheme
    },
    setResourceList(state, resourceList) {
      state.resourceList = resourceList
    }
  },
  getters: {
    getAvater: state => {
      return state.changeAvater
    },
    getWinInfo: state => {
      return state.winInfo
    },
    getUserInfo: state => {
      return state.userInfo
    },
    getAppMode(state, appMode) {
      return state.appMode
    },
    getAccessedRouters: state => {
      return state.accessedRouters
    },
    getBreadcrumb: state => {
      return state.breadcrumb
    },
    getIsLoginAuto: state => {
      return state.isLoginAuto
    },
    getMenuMode: state => {
      return state.menuMode
    },
    getIsLoad: state => {
      return state.isLoadRouter
    },
    getResourceTree: state => {
      return state.resourceTree
    },
    getMenuObject: state => {
      return state.menuObject
    },
    getmenuTree: state => {
      return state.menuTree
    },
    getTheme: state => {
      return state.theme
    },
    getBreadTheme: state => {
      return state.breadTheme
    },
    getOrgType: state => {
      return state.orgType
    },
    getResourceList: state => {
      return state.resourceList
    },
    getIsCompanyUser: state => {
      return state.isCompanyUser
    },
    getAppKey: state => {
      return state.appKey
    },
    getCollapse: state => {
      return state.collapse
    }
  },
  actions: {
    setWinInfo(context, winInfo) {
      context.commit('setWinInfo', winInfo)
    },
    getMenuPermission(context, route, isShow) {
      context.commit('setmenuTree', [])
      return new Promise((resolve, reject) => {
        Vue.fetch
          .post('/apiv1/auth/queryUserResourceTree', {}, {}, isShow)
          .then(data => {
            if (data.code === '00000000') {
              let result = {}
              let routerIds = {}
              context.commit(
                'setResourceTree',
                data.payload.results.resourceTree
              )
              let resourceObj = {}

              getAllResourceObj(data.payload.results.resourceTree, resourceObj)

              context.commit('setResourceList', resourceObj)

              // 过滤菜单，获得有权限的菜单
              let object2 = Object.assign({}, data.payload.results.resourceTree)

              object2 = filterStatus(object2)

              filterResource(object2, result)

              let temp = getRouterMap()

              // 根据权限菜单获取过滤出有权限的路由，然后动态添加路由
              let accessedRouters = filterAsyncRouter(temp, result)

              route.addRoutes(accessedRouters)
              console.log('====添加动态路由===')

              // 修正菜单url,根据后端返回的ID，匹配路由配置的ID，修正路由菜单URL
              RouterIdS(accessedRouters, routerIds)
              setMenu(object2, routerIds)

              // 最终的路由结果
              let routerResult = constantRouter.concat(accessedRouters)

              let menuJson = filterMenu(object2['children'])

              let menuResult = restructureMenu(menuJson)

              context.commit('setmenuTree', menuResult)

              context.commit('setAccessedRouters', routerResult)
              context.commit('setIsLoadrouter', true)
              context.commit('setmenuObject', result)

              let menuArray = object2['children']
              if (menuArray) {
                // 解析第一个路由菜单
                let len = menuArray.length
                let isSelect = false
                let re = new RegExp(/(http[s]?|ftp):\/\/[^\\/\\.]+?\..+\w$/i)
                for (let i = 0; i < len; i++) {
                  let defaultMenu = object2['children'][i]
                  if (defaultMenu.resourceType !== 1) {
                    continue
                  }
                  if (re.test(defaultMenu.url) || defaultMenu.url === '/doc') {
                    continue
                  }
                  if (isSelect) {
                    break
                  }
                  let child = defaultMenu.children

                  if (child && child.length > 0) {
                    let url = ''
                    let childLen = child.length
                    for (let j = 0; j < childLen; j++) {
                      let childObj = child[j]
                      if (childObj.resourceType !== 1) {
                        continue
                      }
                      let childUrl = childObj.url
                      if (re.test(childUrl) || childUrl === '/doc') {
                        continue
                      }
                      if (childUrl.startsWith('/')) {
                        url = path.resolve(childUrl)
                      } else {
                        url = path.resolve(defaultMenu.url, childUrl)
                      }
                      isSelect = true
                      resolve(url)
                      break
                    }
                    if (!isSelect) {
                      isSelect = true
                      resolve(defaultMenu.url)
                    }
                  } else {
                    isSelect = true
                    resolve(defaultMenu.url)
                    break
                  }
                }
                // 解析第一个路由菜单
              } else {
                reject(menuArray)
              }
            } else {
              reject(data)
            }
          })
          .catch(data => {
            reject(data)
          })
      })
    },
    setTheme(context, theme) {
      context.commit('setTheme', theme)
    },
    setBreadTheme(context, breadTheme) {
      context.commit('setBreadTheme', breadTheme)
    },
    setAppMode(context, appMode) {
      context.commit('setAppMode', appMode)
    },
    setMenuMode(context, mode) {
      context.commit('setMenuMode', mode)
    },
    setOrgType(context, orgType) {
      context.commit('setOrgType', orgType)
    },
    setBreadcrumb(context, breadcrumb) {
      context.commit('setBreadcrumb', breadcrumb)
    },
    setIsLoginAuto(context, isLoginAuto) {
      context.commit('setIsLoginAuto', isLoginAuto)
    },
    setIsCompanyUser(context, isCompanyUser) {
      context.commit('setIsCompanyUser', isCompanyUser)
    },
    setUserInfo(context, userInfo) {
      context.commit('setUserInfo', userInfo)
    },
    setAppKey(context, appKey) {
      context.commit('setAppKey', appKey)
    },
    setAvater(context, changeAvater) {
      context.commit('setAvater', changeAvater)
    },
    setCollapse(context, collapse) {
      context.commit('setCollapse', collapse)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js